import React from "react";
import { Col } from "antd";

import { useBreakpoint } from "../../hooks/useWindowSize";
import AdHelper from "../shared/ad/AdHelper";

const AdInRow = ({ count, children }) => {
  const { mobileView, width } = useBreakpoint();
  
  // Determine how often to place ads based on screen size
  // Desktop (≥1024px): every 8 items
  // Tablet: every 4 items
  // Mobile: every 2 items
  const adRowCount = width >= 1024 ? 8 : !mobileView ? 4 : 2;
  const placeAd = count % adRowCount === 0;
  
  return (
    <>
      {children}
      {/* Insert ad banner after every X items */}
      {placeAd && (
        <Col
          md={24}
          style={{
            padding: "1em",
            marginTop: "2em"
          }}
        >
          <AdHelper page="news" />
        </Col>
      )}
    </>
  );
};

export default AdInRow;